(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hearth-product"]) return;
  try {
    
(() => {
  const requests = new WeakMap();
  function ready(root = document) {
    root.querySelectorAll('[data-hp-size-form]').forEach(form => form.closest('.hp').classList.add('hp--size-ready'));
  }
  async function update(section, target, push) {
    const previous = requests.get(section);
    if (previous) previous.abort();
    const controller = new AbortController();
    requests.set(section, controller);
    const selected = target.searchParams.get('variant');
    const status = section.querySelector('[data-hp-size-status]');
    section.setAttribute('aria-busy', 'true');
    if (status) status.textContent = status.dataset.updating;
    section.querySelectorAll('.hp__quote button[type="submit"]').forEach(button => button.disabled = true);
    try {
      const request = new URL(target);
      request.searchParams.set('section_id', section.dataset.hpSection);
      const response = await fetch(request, {signal:controller.signal, credentials:'same-origin'});
      if (!response.ok) throw new Error('Size unavailable');
      const documentNext = new DOMParser().parseFromString(await response.text(), 'text/html');
      const next = documentNext.querySelector('.hp[data-hp-section]');
      if (!next || next.dataset.hpVariant !== selected || !next.querySelector('[data-hp-size]')) throw new Error('Size unavailable');
      if (controller.signal.aborted) return;
      const values = new Map();
      section.querySelectorAll('.hp__quote input:not([type="hidden"]), .hp__quote textarea, .hp__quote select[name^="contact[Preference"], .hp__quote select[name="showroom"]').forEach(input => values.set(input.name, input.value));
      next.querySelectorAll('.hp__quote input:not([type="hidden"]), .hp__quote textarea, .hp__quote select[name^="contact[Preference"], .hp__quote select[name="showroom"]').forEach(input => {if (values.has(input.name)) input.value = values.get(input.name);});
      const open = new Set(Array.from(section.querySelectorAll('details[open]')).map(el => el.id).filter(Boolean));
      next.querySelectorAll('details[id]').forEach(el => el.open = open.has(el.id));
      const focusSize = section.querySelector('[data-hp-size]') === document.activeElement;
      section.replaceWith(next);
      ready(next.parentElement);
      if (push) history.pushState({}, '', target);
      const message = next.querySelector('[data-hp-size-status]');
      if (message) message.textContent = message.dataset.updated;
      if (focusSize) next.querySelector('[data-hp-size]').focus({preventScroll:true});
      document.dispatchEvent(new CustomEvent('hearth:size-changed', {detail:{variantId:selected,sectionId:next.dataset.hpSection}}));
    } catch (error) {
      if (error.name !== 'AbortError') window.location.assign(target.toString());
    }
  }
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-hp-size]');
    if (!select) return;
    const target = new URL(window.location.href);
    target.searchParams.set('variant', select.value);
    update(select.closest('.hp'), target, true);
  });
  document.addEventListener('submit', event => {
    if (event.target.matches('[data-hp-size-form]')) {
      event.preventDefault();
      const target = new URL(window.location.href);
      target.searchParams.set('variant', event.target.querySelector('[data-hp-size]').value);
      update(event.target.closest('.hp'), target, true);
    }
  });
  window.addEventListener('popstate', () => {
    const section = document.querySelector('.hp[data-hp-section]');
    const select = section?.querySelector('[data-hp-size]');
    if (!select) return;
    const target = new URL(window.location.href);
    if (!target.searchParams.has('variant')) target.searchParams.set('variant', select.options[0].value);
    if (target.searchParams.get('variant') !== section.dataset.hpVariant) update(section, target, false);
  });
  document.addEventListener('shopify:section:load', () => ready());
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => ready());
  else ready();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mattress-collection-landing"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('mattress-carousel')) {
  customElements.define('mattress-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.mattress-featured-grid');
      this.buttons = [...this.querySelectorAll('[data-direction]')];
      this.update = () => {
        this.buttons[0].disabled = this.track.scrollLeft <= 2;
        this.buttons[1].disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
      };
      this.onclick = event => {
        const button = event.target.closest('[data-direction]');
        if (!button) return;
        this.track.scrollBy({left: Number(button.dataset.direction) * (this.track.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      this.track.addEventListener('scroll', this.update, {passive: true});
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.track.removeEventListener('scroll', this.update);
      this.observer.disconnect();
    }
  });
}


(() => {
  const links = document.querySelectorAll('.mattress-filter-link');
  if (!links.length) return;
  const update = () => {
    const current = new URL(window.location.href);
    document.querySelectorAll('[class*="refine-by-"][class$="-value"]').forEach(value => {
      const clean = value.textContent.trim().replace(/^(Construction|Comfort|Size)_/, '');
      if (value.textContent.trim() !== clean) value.textContent = clean;
    });
    links.forEach(link => {
      const next = new URL(link.dataset.collectionUrl, window.location.origin);
      next.search = current.search;
      const key = link.dataset.filterKey;
      const tag = link.dataset.filterTag;
      const selected = next.searchParams.get(key) === tag;
      next.searchParams.delete('page');
      next.searchParams.delete('pf_page');
      next.searchParams.delete('preview_theme_id');
      if (selected) next.searchParams.delete(key);
      else next.searchParams.set(key, tag);
      next.hash = 'mattress-catalog';
      link.href = next.pathname + next.search + next.hash;
      link.classList.toggle('is-active', selected);
      if (selected) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });
  };
  const current = new URL(window.location.href);
  const legacyTags = current.pathname.split('/')[3];
  if (legacyTags && current.pathname.startsWith('/collections/mattresses/')) {
    const tags = Array.from(links).map(link => ({ tag: link.dataset.filterTag, key: link.dataset.filterKey }));
    legacyTags.split('+').forEach(handle => {
      const match = tags.find(item => item.tag.toLowerCase().replace(/ /g, '-') === handle);
      if (match) current.searchParams.set(match.key, match.tag);
    });
    current.pathname = '/collections/mattresses';
    current.hash = 'mattress-catalog';
    window.location.replace(current.href);
    return;
  }
  update();
  document.addEventListener('click', event => {
    if (event.target.closest('.mattress-filter-link')) update();
  }, true);
  document.addEventListener('pointerover', event => { if (event.target.closest('.mattress-filter-link')) update(); }, true);
  document.addEventListener('focusin', event => { if (event.target.closest('.mattress-filter-link')) update(); }, true);
  window.addEventListener('popstate', update);
  new MutationObserver(update).observe(document.body, { childList: true, subtree: true });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["speed-queen-landing"] && !Shopify.designMode) return;
  try {
    
function initSpeedQueen(root=document){root.querySelectorAll('[data-sq-page]').forEach(page=>{if(page.dataset.ready)return;page.dataset.ready='true';page.querySelectorAll('[data-sq-units]').forEach(units=>{const selected={type:'all',warranty:'all'};const cards=Array.from(units.querySelectorAll('[data-sq-unit]'));const buttons=Array.from(units.querySelectorAll('[data-sq-filter]'));const count=units.querySelector('[data-sq-result-count]');const empty=units.querySelector('[data-sq-empty]');const reset=units.querySelector('[data-sq-reset]');const update=()=>{let visible=0;cards.forEach(card=>{const matchesType=selected.type==='all'||card.dataset.unitType===selected.type;const matchesWarranty=selected.warranty==='all'||card.dataset.unitWarranty===selected.warranty;card.hidden=!(matchesType&&matchesWarranty);if(!card.hidden)visible++;});buttons.forEach(button=>button.setAttribute('aria-pressed',String(selected[button.dataset.sqFilter]===button.dataset.value)));count.textContent=units.dataset.countTemplate.replace('__COUNT__',String(visible));empty.hidden=visible!==0;reset.hidden=selected.type==='all'&&selected.warranty==='all';};buttons.forEach(button=>button.addEventListener('click',()=>{selected[button.dataset.sqFilter]=button.dataset.value;update();}));reset.addEventListener('click',()=>{selected.type='all';selected.warranty='all';update();});units.querySelector('[data-sq-unit-filters]').hidden=false;units.querySelector('[data-sq-filter-summary]').hidden=false;update();});page.querySelectorAll('[data-sq-select]').forEach(select=>select.addEventListener('change',()=>{select.closest('[data-sq-family]').querySelectorAll('[data-sq-config]').forEach(panel=>{panel.hidden=panel.dataset.sqConfig!==select.value;});}));page.querySelectorAll('[data-sq-cart]').forEach(form=>form.addEventListener('submit',async event=>{event.preventDefault();const button=form.querySelector('button');if(button.disabled)return;const status=form.querySelector('[data-sq-status]');button.disabled=true;status.textContent=page.dataset.adding;try{const response=await fetch(form.action+'.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(button.dataset.idOne),quantity:1},{id:Number(button.dataset.idTwo),quantity:1}]})});const data=await response.json();if(!response.ok)throw new Error(data.description||page.dataset.error);window.location.assign(form.dataset.cartUrl);}catch(error){status.textContent=error.message||page.dataset.error;button.disabled=false;}}));});}
initSpeedQueen();document.addEventListener('shopify:section:load',event=>initSpeedQueen(event.target));

  } catch(e) { console.error(e); }
})();
})();
